import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { balanceSummary, fullName, money, lessonTypeLabel, polishDate } from './clientPortalSelectors';
import { localizeSystemText } from '../../i18n/messages';

export function BillingSummary({ ledger, client }) {
  const { t: tr, i18n } = useTranslation();
  const summary = ledger && ledger.summary;
  return (
    <section className="client-portal__card client-portal__billing">
      <h2>{tr("client:payerSettlement_58")}</h2><p className="text-muted">{tr("client:allStudents_59")} <span>{fullName(client)}</span></p>
      {summary && summary.assignmentStatus === 'ready' ? (
        <>
          {summary.years.map(item => (
            <p key={item.schoolYearStartYear}>{tr('billing:yearScope.balance')} {item.schoolYearStartYear}/{String(item.schoolYearStartYear + 1).slice(-2)}:
              {' '}<span>{localizeSystemText(balanceSummary(item.balanceCents / 100).label, tr)}</span>: <strong>{money(Math.abs(item.balanceCents) / 100, i18n.language)}</strong>
            </p>
          ))}
          <p>{tr('billing:yearScope.overall')}: {money(summary.overallBalanceCents / 100, i18n.language)}</p>
          <small>{tr('billing:yearScope.noOffset')}</small>
        </>
      ) : <p>{tr("client:settlementDataUnavailable_60")}</p>}
    </section>
  );
}
BillingSummary.propTypes = { ledger: PropTypes.object, client: PropTypes.object.isRequired };
BillingSummary.defaultProps = { ledger: null };

export function PackageCard({ item, lessonTypes }) {
  const { t: tr, i18n } = useTranslation();
  const balance = item.balance || {};
  const status = { awaitingPayment: tr("client:awaitingPayment_61"), active: tr("manage:active_338"), expired: tr("client:expired_62"), depleted: tr("common:legacyOption8"), cancelled: tr("common:legacyOption9") }[item.status] || item.status;
  const warnings = { awaitingPayment: tr("client:thePackageWillBecomeActiveOncePaymentIsRecorded_63"), endingSoon: tr("client:thePackageIsRunningLow_64") };
  return (
    <article className="client-portal__package-card">
      <div><h3>{item.name}</h3><p className="text-muted">{lessonTypeLabel(item.classTypeId, lessonTypes, i18n.language)}</p></div>
      <p className="client-portal__status">{status}</p>
      {item.participationStrategy === 'shared_students' && <p>{tr("client:sharedPackageTotalUsageForThePackage_65")}</p>}
      {(!Array.isArray(item.eligibleStudentIds) || !item.eligibleStudentIds.length) && <p>{tr("client:payersPackageStudentAllocationUnavailable_66")}</p>}
      <div className="client-portal__package-counts">
        <span>{tr(item.status === 'expired' ? "client:unusedUnits" : "client:available_67")} <strong>{balance.availableUnits == null ? '—' : balance.availableUnits}</strong></span>
        <span>{tr("client:reserved_68")} <strong>{balance.reservedUnits == null ? '—' : balance.reservedUnits}</strong></span>
        <span>{tr("client:used_69")} <strong>{balance.consumedUnits == null ? '—' : balance.consumedUnits}</strong></span>
      </div>
      {item.validityEndDate && <p>{tr("client:validUntil_70")} {polishDate(item.validityEndDate, false, i18n.language)}</p>}
      {item.paymentDueDate && <p>{tr("client:paymentDue_71")} {polishDate(item.paymentDueDate, false, i18n.language)}</p>}
      {(item.warnings || []).map(warning => <p className="client-portal__warning" key={warning}>{warnings[warning] || warning}</p>)}
    </article>
  );
}
PackageCard.propTypes = { item: PropTypes.object.isRequired, lessonTypes: PropTypes.array.isRequired };
export function AssociationNotice() {
  const { t: tr } = useTranslation(); return <p className="client-portal__warning">{tr("client:someDataCannotBeAssignedToAStudent_72")}</p>;
}
